var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9262 13.9686C26.9262 13.0799 26.8475 12.2361 26.7125 11.4149H14V16.4886H21.2787C20.9525 18.1536 19.9962 19.5599 18.5787 20.5161V23.8911H22.9212C25.4637 21.5399 26.9262 18.0749 26.9262 13.9686Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 27.1647C17.6448 27.1647 20.6936 25.9497 22.9211 23.891L18.5786 20.516C17.3636 21.326 15.8223 21.821 13.9998 21.821C10.4786 21.821 7.4973 19.4472 6.42855 16.241H1.95105V19.7172C4.1673 24.1272 8.72355 27.1647 13.9998 27.1647Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42875 16.2415C6.1475 15.4315 6.00125 14.5652 6.00125 13.6652C6.00125 12.7652 6.15875 11.899 6.42875 11.089V7.61273H1.95125C1.02875 9.43523 0.5 11.4827 0.5 13.6652C0.5 15.8477 1.02875 17.8952 1.95125 19.7177L6.42875 16.2415Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 5.50864C15.9911 5.50864 17.7685 6.19489 19.1748 7.53364L23.0223 3.68614C20.6936 1.50364 17.6448 0.164886 13.9998 0.164886C8.72355 0.164886 4.1673 3.20239 1.95105 7.61239L6.42855 11.0886C7.4973 7.88239 10.4786 5.50864 13.9998 5.50864Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.419b0e47164b6ffec29d28f4f7ee8436.svg";
export { ForwardRef as ReactComponent };